import React from 'react'
import { useTranslation } from 'react-i18next'

import FullPlacesFilterV2 from './FullPlacesFilterV2'
import ActivatedFilter from '../../../components/filter/ActivatedFilter'

const PlaceFiltersList = ({ types, ...props }) => {
  const { t } = useTranslation('places')

  return (
    <>
      <FullPlacesFilterV2 label={t('filters.levels')} placeLevelsOnly types={types} {...props} />
      <ActivatedFilter />
    </>
  )
}

export default PlaceFiltersList
